import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import { Modal } from "pepsico-ds";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";

export default function OutcomeRuleSelectorModal({
  activity,
  selectedOutcomeIndex,
  addOutcomeRule,
  onCloseOutcomeRuleModal,
  showOutcomeRuleModal,
}) {
  const [remainingRuleDefinitions, setRemainingRuleDefinitions] = useState([]);
  const [selectedRuleDefinitionIndex, setSelectedRuleDefinitionIndex] =
    useState(null);

  useEffect(() => {
    const currentAddedRuleSlugs = activity?.outcomes[
      selectedOutcomeIndex
    ]?.outcomeRules?.map((rule) => rule.ruleDefinition.slug);
    const currentAddedRulesWithCount = {};
    currentAddedRuleSlugs.forEach((slug) => {
      if (currentAddedRulesWithCount[slug]) {
        currentAddedRulesWithCount[slug] += 1;
      } else {
        currentAddedRulesWithCount[slug] = 1;
      }
    });
    const possibleRuleDefinitions =
      activity.outcomes[selectedOutcomeIndex]?.outcomeDefinition?.rules?.filter(
        (rule) => rule.hidden !== true
      ) || [];

    const remRuleDefinitions = possibleRuleDefinitions.filter((ruleDefinition) => {
      if (ruleDefinition.maxAllowed === null) {
        return true;
      } else if (currentAddedRulesWithCount[ruleDefinition.slug]) {
        return (
          currentAddedRulesWithCount[ruleDefinition.slug] < ruleDefinition.maxAllowed
        );
      }
      return true;
    });
    setRemainingRuleDefinitions(remRuleDefinitions);
  }, [activity, selectedOutcomeIndex]);

  return (
    <Modal
      showModal={showOutcomeRuleModal}
      onCloseModal={onCloseOutcomeRuleModal}
      title="Add Rule"
      showTertiaryButton={false}
      showLink={false}
      secondaryButtonProps={{
        size: "medium",
        text: "Cancel",
        variant: "secondary",
        onClick: onCloseOutcomeRuleModal,
      }}
      primaryButtonProps={{
        size: "medium",
        text: "Add",
        variant: "primary",
        disabled: selectedRuleDefinitionIndex !== null ? false : true,
        onClick: () => {
          addOutcomeRule(remainingRuleDefinitions[selectedRuleDefinitionIndex]);
        },
      }}
    >
      <div className="w-100">
        <FormControl>
          <RadioGroup
            aria-labelledby="outcome-selector-modal"
            defaultValue="female"
            name="radio-buttons-group"
            onChange={(e) => setSelectedRuleDefinitionIndex(e.target.value)}
          >
            {remainingRuleDefinitions?.map((rule, index) => (
              <FormControlLabel
                key={index}
                value={index}
                control={<Radio />}
                label={rule.name}
              />
            ))}
          </RadioGroup>
        </FormControl>
      </div>
    </Modal>
  );
}

OutcomeRuleSelectorModal.propTypes = {
  activity: PropTypes.object.isRequired,
  selectedOutcomeIndex: PropTypes.number.isRequired,
  addOutcomeRule: PropTypes.func.isRequired,
  onCloseOutcomeRuleModal: PropTypes.func.isRequired,
  showOutcomeRuleModal: PropTypes.bool.isRequired,
};
